import { render, staticRenderFns } from "./DetailPop.vue?vue&type=template&id=257d3d16&scoped=true&"
import script from "./DetailPop.vue?vue&type=script&lang=js&"
export * from "./DetailPop.vue?vue&type=script&lang=js&"
import style0 from "./DetailPop.vue?vue&type=style&index=0&id=257d3d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d3d16",
  null
  
)

export default component.exports